module.exports = __webpack_public_path__ + "img/100-dante-poster-image.ada4f535.jpg";